/**
 * 获取钉钉环境中url地址栏的corpKey的值
 * @returm String
 */
/**
 * 获取钉钉环境中url地址栏的corpKey的值
 * @returm String
 */
export const getCorpKey = () => {
  // 获取地址参数：corpKey
  const search = window.location.search
  let corpKey = null
  if (search) {
    corpKey = search.split('=')[1]
  }
  return corpKey
}



// WEBPACK FOOTER //
// ./src/utils/url.js